export const normalizeClassroom = (classroom: string | null | undefined): string => {
    return classroom?.replace(/\s+/g, "-") || "";
  };
  